// components/UserLocationMap.js
import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const UserLocationMap = () => {
  const [location, setLocation] = useState(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        setLocation({ lat: latitude, lng: longitude });
      },
      (err) => {
        console.error(err);
        alert('Failed to get your location');
      }
    );
  }, []);

  return (
    <LoadScript googleMapsApiKey={`AIzaSyAf1_BBRbkj36vBHTVvqZ1T4QJfGC9IMsU`}>
      {location && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={location}
          zoom={14}
        >
          <Marker position={location} />
        </GoogleMap>
      )}
    </LoadScript>
  );
};

export default UserLocationMap;
